import { render, staticRenderFns } from "./two-column.vue?vue&type=template&id=6d7fe965&"
import script from "./two-column.vue?vue&type=script&lang=js&"
export * from "./two-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports